export default __webpack_public_path__ + "static/media/Delivery_Tracking_Orange.c10a2cf9.svg";